import { ModuleTitle } from './module-title.component';

export * from './module-title.component';
export default ModuleTitle;

ModuleTitle.define('der-ui-module-title');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-module-title': ModuleTitle;
    }
}
